import React from "react";
import { Button, Grid, Typography } from "@sumprio/ui";
import "./PdfPreviewPanel.scss";

type PdfPreviewPanelProps = {
  loading: boolean;
  error: boolean;
  blobUrl: string | null;
  fallbackUrl: string;
  title: string;
  classNamePrefix: "view-document-modal" | "view-attachment-modal";
};

function buildPdfEmbedSrc(blobUrl: string): string {
  const baseUrl = blobUrl.split("#")[0];
  // Fit page in view so trackpad/mouse do not show unnecessary scrollbars.
  return `${baseUrl}#view=Fit&navpanes=0&toolbar=1`;
}

export function PdfPreviewPanel({
  loading,
  error,
  blobUrl,
  fallbackUrl,
  title,
  classNamePrefix,
}: PdfPreviewPanelProps) {
  if (loading) {
    return (
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding="2xl"
      >
        <Typography variant="body" bodySize="md" bodyWeight="regular" color="secondary">
          Loading…
        </Typography>
      </Grid>
    );
  }

  if (blobUrl) {
    return (
      <div className="pdf-preview-panel">
        <iframe
          src={buildPdfEmbedSrc(blobUrl)}
          title={title}
          className="pdf-preview-panel__iframe"
        />
      </div>
    );
  }

  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="md"
      padding="2xl"
      className={`${classNamePrefix}__fallback`}
    >
      <Typography variant="body" bodySize="sm" bodyWeight="regular" color="secondary">
        {error
          ? "Could not load PDF preview. You can open or download the file instead."
          : "PDF preview is not available."}
      </Typography>
      {fallbackUrl ? (
        <Button
          variant="brand-tertiaryColor"
          size="sm"
          onClick={() => window.open(fallbackUrl, "_blank", "noopener,noreferrer")}
        >
          Open in new tab
        </Button>
      ) : null}
    </Grid>
  );
}
